import { Tooltip as KendoTooltip, TooltipProps as KendoTooltipProps } from '@progress/kendo-react-tooltip';
import styled from 'styled-components';
import React from 'react';

export type TooltipProps = KendoTooltipProps & {
    small?: boolean;
    whitespace?: boolean;
};

const Styles = styled.div
    .withConfig({ shouldForwardProp: (prop) => !['small', 'whitespace'].includes(prop) })
    .attrs((props: TooltipProps) => ({ className: 'app-tooltip-wrap', small: false }))`
    &&&.app-tooltip-wrap {
        display: flex;
        justify-content: center;
        align-items: center;

        & > * {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`;

const StyledTooltip = styled(KendoTooltip)
    .withConfig({ shouldForwardProp: (prop) => !['small', 'whitespace'].includes(prop) })
    .attrs<TooltipProps>((props) => ({
        className: `app-tooltip ${props.className}${props.small ? ' app-tooltip-small' : ''}${
            props.whitespace ? ' app-tooltip-whitespace' : ''
        }`,
    }))<TooltipProps>`
    &&&.app-tooltip {
        //font-size: 1rem;

        .k-tooltip {
            font-size: 0.71em;
            padding: 0.86em 1.14em;
            border-radius: 0.14em;

            font-style: normal;
            font-weight: 500;
            line-height: 1.28em;

            color: ${(props) => props.theme.colors.snow_white};
            background: ${(props) => props.theme.colors.base_grey};

            .tooltip-row {
                display: block;
                text-align: left;
                padding-bottom: 0.5em;
            }

            .tooltip-row-title {
                display: block;
                font-size: 0.71em;
                line-height: 1.28em;
                letter-spacing: 0.2px;
                padding: 0;
                margin: 0;
                color: ${(props) => props.theme.colors.road_grey_500};
            }
        }

        &.app-tooltip-small {
            .k-tooltip {
                padding: 0.28em 0.42em;
            }
        }

        &.app-tooltip-whitespace {
            white-space: pre;

            .k-tooltip {
                letter-spacing: 0;
                font-weight: normal;
                font-size: 0.71em;
                font-feature-settings: 'liga' 0, 'calt' 0;
                font-variation-settings: normal;
                font-family: Consolas, 'Courier New', monospace !important;
                text-align: left;
            }
        }
    }
`;

export function Tooltip({ ...tooltipProps }: TooltipProps) {
    return (
        <Styles className="app-tooltip-wrap">
            <StyledTooltip {...tooltipProps}></StyledTooltip>
        </Styles>
    );
}
